































































































































import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import Appconst from '../../../lib/appconst';
import ScientficProjectAddInfo from './scientficProjectAddInfo.vue'
@Component({
    name:'scientficProjectAdd',
    components: {
        ScientficProjectAddInfo
    }
})
export default class ScientficProjectAdd extends AbpBase  {
    @Prop() editData:Object;
    initData:any = {
        btnLoading:false
    }
    //提交
    async Submit() {
        (this as any).$refs.scientficProjectAddInfo.Submit('add');
    }
    mounted() {
    }

}
